import React from "react";
import styles from "./AssistantForm.module.scss";
import { Header } from "./components/Header";
import { Card } from "./components/Card";
import { useDispatch, useSelector } from "react-redux";
import { getAssistantList } from "../../utils/api/actions/assistant";
import Button from "../../ui/Button/Button";
import { PlusIcon } from "@radix-ui/react-icons";
import { useNavigate } from "react-router-dom";

export default function AssistantForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { dataAssistants } = useSelector((state) => state.assistant);

  const id =
    useSelector((state) => state.user?.data?.id) ||
    localStorage.getItem("@storage_User_Id");

  React.useEffect(() => {
    if (id) {
      dispatch(getAssistantList(id));
    }
  }, [dispatch, id]);

  const handleClickNew = () => {
    navigate("new");
  };

  if (!dataAssistants) {
    return (
      <div className={styles.wrapperWelcome}>
        <div className={styles.welcome}>
          <h1>
            Добро пожаловать на платформу <br /> AI-ассистентов!
          </h1>
          <p>
            Здесь вы сможете создать умных ассистентов, подключить каналы
            коммуникации и автоматизировать общение с клиентами.
          </p>
        </div>
        <Button
          onClick={handleClickNew}
          title={"Создать первого ассистента"}
          leftIcon={<PlusIcon color="white" />}
        />
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <Header />
      <Card />
    </div>
  );
}
